module.exports = __webpack_public_path__ + "media/icons/white_marker-ac58d34e.svg";